function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import React from "react";
import PropTypes from "prop-types";
import { ScreenReaderOnly } from "@xo-union/ui-accessibility";
import { singular, plural, humanTermType } from "../humanTerms.js";
import { InclusiveRange } from "../Range/index.js";
var ScreenReaderDescription = function ScreenReaderDescription(_ref) {
  var id = _ref.id,
    terms = _ref.terms,
    visibleSlidesIndexRange = _ref.visibleSlidesIndexRange,
    totalSlidesCount = _ref.totalSlidesCount,
    containerRef = _ref.containerRef;
  var humanReadableRange = _mapInstanceProperty(visibleSlidesIndexRange).call(visibleSlidesIndexRange, function (num) {
    return num + 1;
  });
  var min = humanReadableRange.min,
    max = humanReadableRange.max;
  var announcementTimeout = React.useRef();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    shouldAnnounceChanges = _React$useState2[0],
    setShouldAnnounceChanges = _React$useState2[1];

  /**
   * Avoid announcing state of carousels on page load and resize, only do it on change
   * when focused on an element in the carousel
   */
  React.useEffect(function () {
    if (containerRef.current.contains(document.activeElement)) {
      setShouldAnnounceChanges(true);
    }
    clearTimeout(announcementTimeout.current);
    announcementTimeout.current = _setTimeout(function () {
      setShouldAnnounceChanges(false);
    }, 2000);
    return function () {
      clearTimeout(announcementTimeout.current);
    };
  }, [min, max, containerRef]);
  var style = shouldAnnounceChanges ? undefined : {
    display: 'none'
  };
  var countPhrase = humanReadableRange.length === 1 ? "".concat(singular(terms.slides), " number ").concat(min) : "".concat(plural(terms.slides), " ").concat(min, " to ").concat(max);
  return /*#__PURE__*/React.createElement(ScreenReaderOnly, {
    "aria-live": "assertive",
    "aria-atomic": "true",
    style: style,
    id: id
  }, "Showing ".concat(countPhrase, " out of ").concat(totalSlidesCount));
};
process.env.NODE_ENV !== "production" ? ScreenReaderDescription.propTypes = {
  id: PropTypes.string,
  terms: humanTermType(['slides']),
  visibleSlidesIndexRange: PropTypes.instanceOf(InclusiveRange),
  totalSlidesCount: PropTypes.number,
  containerRef: PropTypes.shape({
    current: PropTypes.shape({
      contains: PropTypes.func
    })
  })
} : void 0;
export default ScreenReaderDescription;